import { jsx } from "react/jsx-runtime";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { validateTidalLicense } from "../../base/index.js";
function PlaylistAddCheck(props) {
  return /* @__PURE__ */ jsx(
    PlaylistAddCheckIcon,
    {
      "data-testid": "PlaylistAddCheck",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PlaylistAddCheck",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
PlaylistAddCheck.tidalIconMeta = {
  categories: "miscellaneous",
  name: "PlaylistAddCheck"
};
validateTidalLicense();
export {
  PlaylistAddCheck
};
//# sourceMappingURL=PlaylistAddCheck.js.map
